var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scene",attrs:{"id":'scene-' + _vm.scene.id_scene},on:{"click":function($event){return _vm.selectScene()}}},[_c('div',{staticClass:"scene-image"},[_c('img',{attrs:{"src":_vm.scene.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }